// LegalFooter.jsx

import "./Footer.css";

import { useState } from "react";

// const disclaimerData = [
//   {
//     title: "1. For Educational and Informational Purposes Only",

//     description:
//       "All information, data, and signals (including but not limited to Bullish, Bearish, and Neutral indicators) provided by this application and its parent company, PhronesisTech, are strictly for educational and informational purposes. This application is designed to be an analytical tool for market momentum and should not be construed as a recommendation to buy, sell, or hold any financial instrument.",
//   },

//   {
//     title: "2. Not SEBI Registered Advisors",

//     description:
//       "We are an independent technology and analytics platform. PhronesisTech and the creators of this application are NOT registered with the Securities and Exchange Board of India (SEBI) as Investment Advisors, Research Analysts, or Portfolio Managers. The insights, AI-driven coaching, and technical data provided do not constitute personalized financial or investment advice.",
//   },

//   {
//     title: "3. High Risk of Capital Loss",

//     description:
//       "Trading in the equity markets involves substantial risk. Specifically, trading in Futures and Options (F&O) carries a high degree of leverage and risk, and may not be suitable for all investors. You can lose some or all of your initial investment. You should never trade with money that you cannot afford to lose. All trading decisions made based on the data, Put-Call Ratios, and option chain analytics provided by this platform are made entirely at your own risk.",
//   },

//   {
//     title: "4. No Guarantee of Accuracy or Future Performance",

//     description:
//       "All technical indicators, historical data analysis, and algorithmic signals (including VWAP, RSI, MACD overlays, and AI-driven insights) are based on probabilities and past market behavior. Past performance is strictly not indicative of future results. Markets are highly volatile, and no mathematical model, algorithm, or artificial intelligence can predict market movement with absolute certainty.",
//   },

//   {
//     title: "5. Technological and Algorithmic Limitations",

//     description:
//       "While this application is built for high-speed data processing, users must acknowledge that technology is subject to latency, server downtime, API interruptions, and data feed delays. We do not guarantee uninterrupted access to the platform or the real-time accuracy of third-party market data. PhronesisTech shall not be held liable for any financial losses resulting from system failures, delayed execution, or data anomalies.",
//   },

//   {
//     title: "6. User Independence and Responsibility",

//     description:
//       "By using this application, you acknowledge that you have complete autonomy over your trading account and capital. You agree to conduct your own independent research and due diligence, or consult with a certified financial professional, before executing any trades. PhronesisTech accepts no liability whatsoever for any direct, indirect, or consequential loss arising from the use of this application or reliance on its signals.",
//   },
// ];
const disclaimerData = [
  {
    title: "1. Educational Only",
    description:
      "This platform provides analytical tools for market momentum. All data and signals are strictly for educational and informational use, not financial advice or recommendations.",
  },
  {
    title: "2. Not SEBI Registered",
    description:
      "PhronesisTech is an independent technology platform, not a SEBI-registered Investment Advisor, Research Analyst, or Portfolio Manager. We do not offer personalized financial advice.",
  },
  {
    title: "3. High Risk of Loss",
    description:
      "Equity and F&O trading involve high leverage and significant risk. You may lose your entire investment. Never trade with capital you cannot afford to lose; all decisions are yours alone.",
  },
  {
    title: "4. No Performance Guarantees",
    description:
      "Market indicators and AI signals are based on probability, not certainty. Past performance does not guarantee future results. Markets are volatile, and predictions are never absolute.",
  },
  {
    title: "5. Technical Limitations",
    description:
      "We are not responsible for financial losses due to system latency, server downtime, or third-party data feed delays. Platform access and data accuracy are not guaranteed.",
  },
  {
    title: "6. Your Responsibility",
    description:
      "You retain full autonomy over your trading decisions. Always conduct your own due diligence or consult a professional before trading. PhronesisTech holds no liability for your losses.",
  },
];
const footerBottomLinks = [
  { id: 1, name: "Terms & Conditions" },
  { id: 2, name: "Privacy Policy" },
  { id: 3, name: "Risk Warning" },
];

// const Footer = () => {
//   return (
//     <footer className="legal-footer">
//       {/* =========================
//           DISCLAIMER SECTION
//       ========================= */}

//       <div className="footer-disclaimer">
//         <h3 className="disclaimer-heading">Legal & Risk Disclaimer</h3>

//         {disclaimerData.map((item, index) => (
//           <div key={index} className="disclaimer-block">
//             <span>
//               <h4>
//                 {item.title} : <span>{item.description}</span>
//               </h4>
//             </span>
//           </div>
//         ))}
//       </div>

//       {/* =========================
//           FOOTER BOTTOM
//       ========================= */}

//       <div className="footer-bottom">
//         <p className="footer-p">© 2026 PhronesisTech. All Rights Reserved.</p>

//         <div className="footer-bottom-links">
//           <div className="footer-inner-div">
//             {footerBottomLinks.map((item) => (
//               <span className="footer-bottom-span" key={item?.id}>
//                 {item?.name} {item?.id !== 3 && <span>|</span>}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };import { useState } from "react";

const Footer = () => {
  const [showFull, setShowFull] = useState(false);

  return (
    <footer className="legal-footer">
      <div className="footer-disclaimer-compact">
        <p className="disclaimer-short">
          <strong>Disclaimer:</strong> {disclaimerData[0].description}{" "}
          <span
            className="read-more-link"
            onClick={() => setShowFull(!showFull)}
          >
            {showFull ? "Read Less" : "Read More"}
          </span>
        </p>

        {showFull && (
          <div className="disclaimer-expanded">
            {disclaimerData.slice(1).map((item, index) => (
              <p key={index}>
                <strong>{item.title}:</strong> {item.description}
              </p>
            ))}
          </div>
        )}
      </div>

      <div className="footer-bottom">
        <p className="footer-p">© 2026 PhronesisTech. All Rights Reserved.</p>

        <div className="footer-bottom-links">
          {footerBottomLinks.map((item, i) => (
            <span key={item.id}>
              <span className="footer-bottom-span">{item.name}</span>
              {i < footerBottomLinks.length - 1 && (
                <span className="footer-divider"> | </span>
              )}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
